import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
import './filter/filters.js'
import { marked } from 'marked'
import { version } from '../package.json'

console.log(version)

// import VueSmoothScroll from 'vue2-smooth-scroll'
// Vue.use(VueSmoothScroll)

// var VueScrollTo = require('vue-scrollto')
// Vue.use(VueScrollTo)

Vue.config.productionTip = false

const instance = axios.create({
  baseURL: window.location.hostname.match(/localhost|192.168|10.0/g) ? `http://${window.location.hostname}:8081/static/server/api` : '/static/server/api'
})
instance.defaults.params = {}

var loading = {
  do: 0,
  timeout: false
}

// before a request is made start the nprogress
instance.interceptors.request.use(config => {
  loading.do++
  return config
})

// before a response is returned stop nprogress
instance.interceptors.response.use(response => {
  loading.do--
  return response
})

// VH Calculation
/*
var customViewportCorrectionVariable = 'vh'
function setViewportProperty (doc) {
  var prevClientHeight
  var customVar = '--' + (customViewportCorrectionVariable || 'vh')
  function handleResize () {
    var clientHeight = doc.clientHeight
    if (clientHeight === prevClientHeight) return
    requestAnimationFrame(function updateViewportHeight () {
      if (clientHeight !== prevClientHeight) {
        doc.style.setProperty(customVar, (clientHeight * 0.01) + 'px')
      }
      prevClientHeight = clientHeight
    })
  }
  handleResize()
  return handleResize
}
window.addEventListener('resize', setViewportProperty(document.documentElement))
*/

async function init () {
  /*
   * Initialize Session
   */

  let _response = {}
  try {
    _response = await instance.get('token')
    instance.defaults.headers.common['X-API-KEY'] = _response.data.session.token
    Vue.prototype.$http = instance
  } catch (e) {
    console.warn(e)
  }

  /*
  * Load Translations
  */
  let _translations = []
  try {
    _translations = await instance.get('translations')
  } catch (e) {
    console.warn(e)
  }

  let _d = (await instance.get(`/books`)).data

  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    data () {
      return ({
        translations: _translations.data,
        language: 1,
        loading: loading,
        scrolldirection: false,
        lastScrollTop: 0,
        overlay: false,
        contextOpen: false,
        project: _response.data.project,
        books: _d.toc,
        about: _d.about,
        color: false,
        init: false,
        debounceResize: null,
        nobooks: false,
        mount: false,
        extra: false
      })
    },
    mounted () {
      const e = this.books
      if (this.$route.name === 'books' || this.$route.name === 'books_extra_external') {
        let _index = 0
        if (e.length > 0 && this.$route.params.bookIndex) {
          _index = e.findIndex(m => {
            return +(m.Options.SeriesNumberInteger || m.data.Laufnummer) === +this.$route.params.bookIndex
          })
        }
        this.$root.nobooks = e.length === 0 || _index === -1
        if (e[_index] && e[_index].Id) {
          const params = {
            bookId: e[_index].Id,
            stub: e[_index].Stub,
            extraBook: this.$route.name === 'books_extra_external' ? 'extra' : undefined,
            extraChapter: this.$route.params.extraChapter,
            extraItem: this.$route.params.extraItem
          }
          this.$router.replace({name: 'book',
            params: params
          })
          return
        }
      }
      this.mount = true

      setInterval(() => {
        this.$http.get('token').then((response) => {
          this.$http.defaults.headers.common['X-API-KEY'] = response.data.session.token
        })
      }, 60000)
      window.addEventListener('scroll', () => {
        var st = window.pageYOffset || document.documentElement.scrollTop
        if (st > this.lastScrollTop) {
          this.scrolldirection = 'down'
        }
        if (st < this.lastScrollTop) {
          this.scrolldirection = 'up'
        }
        this.lastScrollTop = st <= 0 ? 0 : st
        this.$emit('window:scroll')
      }, false)
      window.addEventListener('resize', () => {
        if (this.debounceResize) {
          clearTimeout(this.debounceResize)
          this.debounceResize = null
        }
        this.debounceResize = setTimeout(() => {
          this.$emit('window:resize')
        }, 250)
      })
    },
    watch: {
      overlay (state) {
        let e = document.getElementById('body')
        e.style['overflow'] = state === true ? 'hidden' : 'auto'
      }
    },
    methods: {
      stopLoading () {
        this.loading.do = 0
      },
      applyMeta (title, description, image) {
        image = image || ''
        title = title || ''
        description = description || ''

        let identifier = 'data-meta-controlled'
        Array.from(document.querySelectorAll(`[${identifier}]`)).map(el => el.parentNode.removeChild(el))

        let _title = document.createElement('title')
        _title.setAttribute(identifier, '')
        _title.innerHTML = title
        document.head.appendChild(_title)

        let _ogtitle = document.createElement('meta')
        _ogtitle.setAttribute('property', 'og:title')
        _ogtitle.setAttribute('content', title)
        _ogtitle.setAttribute(identifier, '')
        document.head.appendChild(_ogtitle)

        let _description = document.createElement('meta')
        _description.setAttribute('name', 'description')
        _description.setAttribute('content', description)
        _description.setAttribute(identifier, '')
        document.head.appendChild(_description)

        let _ogdescription = document.createElement('meta')
        _ogdescription.setAttribute('property', 'og:description')
        _ogdescription.setAttribute('content', description)
        _ogdescription.setAttribute(identifier, '')
        document.head.appendChild(_ogdescription)
        if (image) {
          let _ogimage = document.createElement('meta')
          _ogimage.setAttribute('property', 'og:image')
          _ogimage.setAttribute('content', image)
          _ogimage.setAttribute(identifier, '')
          document.head.appendChild(_ogimage)
        }
      },
      md (s) {
        return marked.parseInline(s)
      },
      t (key) {
        if (this.translations && this.translations[key]) {
          return this.translations[key][this.language]
        } else {
          return `[!]${key}`
        }
      }
    }
  }).$mount('#app')
}

init()



// WEBPACK FOOTER //
// ./src/main.js